
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges} from 'src/app/shared/commen-function-file';


@Component({
  selector: 'app-faculty-name-popup',
  templateUrl: './faculty-name-popup.component.html',
  styleUrls: ['./faculty-name-popup.component.scss'],
})
export class FacultyNamePopupComponent  implements OnInit {

  addFacultyForm!: FormGroup;
   buttonColorName: any;
   subModuleButtonColor: any | null;
   loggedInUserCompanyID: any;
   loggedInCompanyFiscalyear: any;
   loggedInUserEmpCode: any | null;
   loggedInUserId: any | null;
   loggedInCompanyMDCode: any | null;
   loggedInUserRole: any;
   loggedInUserRoles: any;
   loggedInCompanyReviewCycle: any | null;
   loggedInUserRoleIsEmployee: any;
   fromYear: any;
   selectedYear: any;
   toYear: any;
   selectedYearForCompetency: any = null;
     pmsYears: any = [];
     selectedTypeTabName:any
  getFacultyName: any;
 
   constructor(private datePipe: DatePipe, public sharedService: SharedService,@Inject(MAT_DIALOG_DATA) public data: any,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,  public dialogRef: MatDialogRef<FacultyNamePopupComponent>,
    private PdfDownload: PdfDownloadService, private dataRefreshService: DataRefreshService,) { 
    
    }
 
    ngOnInit() {
      this.selectedTypeTabName = "createcalendar";
      this.buttonColorName = sessionStorage.getItem('buttonColorName');
      this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
      this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
  
      console.log('loggedInUserCompanyID Value:', this.loggedInUserCompanyID); // Debugging
  
      this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
      this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
      if (this.loggedInCompanyFiscalyear) {
        this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
      }
      this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
      this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
      this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
      this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
      if (this.loggedInUserRole) {
        this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      }
      this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
      this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
      if (this.loggedInUserRoles.length == 1) {
        for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
          if (this.loggedInUserRoles[i].displayName == "Employee") {
            this.loggedInUserRoleIsEmployee = true
          }
        }
      }
      this. getpmsyearlist();
      this.addFacultyForm = this.fb.group({
        facultyName: [''],
        contactNumber: [''],
        email: [''],
        details: [''],
        link: ['']
      });
      
    }
  
  
    getpmsyearlist() {
      this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
        this.pmsYears = formatYearRanges(data?.data?.yearRanges);
  
        const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
  
        const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
        
        this.setSelectedYear(yearValue);
  
      });
    }
    
    setSelectedYear(yearValue: string): void {
      const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
      if (selectedYearObj) {
            this.selectedYearForCompetency = selectedYearObj?.year;
           
            let test = selectedYearObj?.year.split('-');
            this.fromYear = test[0];
            this.toYear = test[1];
            this.defaultCallFunctionsList();
            [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
      }
    }
  

    defaultCallFunctionsList() {
   this.getAllFaculty();
    }

    getYearSetupForReimbursement(year: any) {
      this.selectedYearForCompetency = year;
  console.log(   this.selectedYearForCompetency);
  
      this.selectedYear = year;
      // console.log(this.selectedYear)
     
    }
 
 
 
 closeDialog() {
   this.dialogRef.close();
 }

//  getAllFaculty(){
//   let companyId = this.loggedInUserCompanyID;
//       let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
//       let fiscal_year = this.loggedInCompanyFiscalyear;
//       this.httpService.callGetService(this.config.getAllFaculty + fiscal_year+"/"+year+"/"+companyId).subscribe((result: any) => {
//        this.getFacultyName = result.data;
//        console.log("Get Faculty====", this.getFacultyName);
       
//         })     
// }
getAllFaculty() {
  const companyId = this.loggedInUserCompanyID;
  const year = this.selectedYear || this.selectedYearForCompetency;
  const fiscal_year = this.loggedInCompanyFiscalyear;

  this.httpService.callGetService(this.config.getAllFaculty + fiscal_year + "/" + year + "/" + companyId)
    .subscribe((result: any) => {
      this.getFacultyName = result.data;
      console.log("Get Faculty====", this.getFacultyName);

      // Example: Pick the first non-empty faculty
      const selectedFaculty = this.getFacultyName.find((f: any) => f.facultyName);

      if (selectedFaculty) {
        this.addFacultyForm.patchValue({
          facultyName: selectedFaculty.facultyName,
          contactNumber: selectedFaculty.contactNumber,
          email: selectedFaculty.emailId,
          details: selectedFaculty.description,
          link: selectedFaculty.links
        });
      }
    });
}

}
